import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  fr: {
    translation: {
      'app.title': 'Synestesia',
      'auth.login': 'Connexion',
      'auth.signup': 'Inscription',
      'auth.email': 'Email',
      'auth.password': 'Mot de passe',
      'auth.confirmPassword': 'Confirmer le mot de passe',
      'auth.firstName': 'Prénom',
      'auth.lastName': 'Nom',
      'auth.language': 'Langue',
      'auth.country': 'Pays',
      'auth.age': 'Âge',
      'auth.submit': 'Valider',
      'auth.logout': 'Déconnexion',
      'auth.rememberMe': 'Se souvenir de moi',
      'verifyEmail.title': 'Vérifiez votre email',
      'verifyEmail.sentTo': 'Nous avons envoyé un lien de validation à l\'adresse :',
      'verifyEmail.steps': 'Prochaines étapes :',
      'verifyEmail.step1': 'Ouvrez votre boîte de réception',
      'verifyEmail.step2': 'Cliquez sur le lien de validation dans l\'email',
      'verifyEmail.step3': 'Votre compte sera activé et vous pourrez vous connecter',
      'verifyEmail.resend': 'Renvoyer l\'email de validation',
      'verifyEmail.sending': 'Envoi en cours...',
      'verifyEmail.afterVerify': 'Après avoir vérifié votre email, vous pouvez vous connecter.',
      'verifyEmail.goToLogin': 'Aller à la page de connexion →',
      'verifyEmail.emailNotAvailable': 'Adresse email non disponible',
      'verifyEmail.resendSuccess': 'Email de validation renvoyé avec succès',
      'verifyEmail.resendError': 'Erreur lors de l\'envoi de l\'email',
      'emailVerification.loading': 'Vérification en cours...',
      'emailVerification.pleaseWait': 'Veuillez patienter',
      'emailVerification.success': 'Email vérifié !',
      'emailVerification.successMessage': 'Votre adresse email a été vérifiée avec succès.',
      'emailVerification.error': 'Erreur de validation',
      'emailVerification.errorMessage': 'Le lien de validation est invalide ou a expiré.',
      'emailVerification.loginNow': 'Se connecter maintenant',
      'emailVerification.goToLogin': 'Aller à la connexion',
      'emailVerification.createAccount': 'Créer un compte',
      'emailVerification.missingParams': 'Paramètres de validation manquants.',
      'profile.title': 'Mon profil',
      'profile.button': 'Profil',
      'profile.loading': 'Chargement...',
      'profile.save': 'Enregistrer',
      'profile.saving': 'Enregistrement...',
      'profile.saved': '✓ Enregistré !',
      'profile.emailReadOnly': 'L\'email ne peut pas être modifié',
      'profile.currentInfo': 'Vos informations',
      'profile.editInfo': 'Modifier vos informations',
      'profile.notFilled': 'Non renseigné',
      'profile.saveError': 'Erreur lors de la sauvegarde',
      'matrice.title': 'Créer une matrice',
      'matrice.letters': 'Lettres',
      'matrice.specialCharacters': 'Caractères spéciaux',
      'matrice.numbers': 'Chiffres',
      'matrice.days': 'Jours de la semaine',
      'matrice.months': 'Mois de l\'année',
      'matrice.save': 'Enregistrer',
      'matrice.loadLast': 'Charger la dernière matrice',
      'dashboard.title': 'Tableau de bord',
      'document.title': 'Éditeur de document',
      'document.new': 'Nouveau document',
      'document.save': 'Enregistrer',
      'document.exportPDF': 'Exporter en PDF',
      'document.background': 'Arrière-plan',
      'document.previewWithColors': 'Aperçu avec couleurs',
      'document.keyboard': 'Clavier',
      'document.wordCount': 'mots',
      'document.wordCountOne': 'mot',
      'document.wordLimitExceeded': 'Limite de 3000 mots dépassée.',
      'document.loadError': 'Erreur lors du chargement du document',
      'document.saveError': 'Erreur lors de la sauvegarde',
      'documentHistory.title': 'Historique des documents',
      'documentHistory.matrice': 'Matrice',
      'documentHistory.edit': 'Modifier',
      'documentHistory.delete': 'Supprimer',
      'documentHistory.deleting': 'Suppression...',
      'documentHistory.confirmDelete': 'Êtes-vous sûr de vouloir supprimer ce document ?',
      'documentHistory.deleteError': 'Erreur lors de la suppression',
      'history.title': 'Historique des matrices',
      'history.delete': 'Supprimer',
      'history.edit': 'Modifier',
      'history.deleting': 'Suppression...',
      'history.confirmDelete': 'Êtes-vous sûr de vouloir supprimer cette matrice ?',
      'history.deleteError': 'Erreur lors de la suppression',
      'matrice.loadError': 'Erreur lors du chargement de la matrice',
      'matrice.saveError': 'Erreur lors de la sauvegarde',
      'matrice.update': 'Mettre à jour',
      'matrice.updating': 'Mise à jour...',
      'matrice.updated': 'Mis à jour!',
      'matrice.back': '← Retour',
      'matrice.basicGradient': 'Dégradé de base',
      'matrice.random': 'Hasard',
      'matrice.symbolSelect': 'Choisir le symbole',
      'matrice.symbolFor': 'Symbole pour',
      'matrice.symbolMale': 'Mâle',
      'matrice.symbolFemale': 'Femelle',
      'matrice.symbolIndeterminate': 'Indéterminé',
      'matrice.sensationDescribe': 'Décrire la sensation de ce chiffre',
      'matrice.sensationFor': 'Sensation pour',
      'matrice.sensationPlaceholder': 'Décrivez la sensation de ce chiffre',
      'common.cancel': 'Annuler',
      'cookie.message': 'Ce site utilise des cookies pour améliorer votre expérience.',
      'cookie.accept': 'Accepter',
      'cookie.decline': 'Refuser',
      'story.section1': 'Salut moi c\'est Léo. Je suis franco-turc et j\'habite en Normandie',
      'story.section2': 'Voici mon Papa et Ursule',
      'story.section3': 'Deux trucs que J\'aime bien faire : jouer avec des couleurs, et ne rien faire',
      'story.section4': 'Mais bon... il faut aussi aller à l\'école tous les matins',
      'story.section5': 'et à l\'école j\'ai eu quelques difficultés à comprendre des choses qui étaient facile à comprendre (d\'après la maîtresse)',
      'story.section6': 'Mais heureusement mon papa il est trop fort pour inventer des trucs... et donc on a essayé de trouver des solutions',
      'story.section7': 'Et c\'est là qu\'on a réalisé que j\'étais synesthète (que même la maîtresse elle connaissait pas le mot)',
      'story.section8': 'On a codé ensemble un système pour associer les lettres et les couleurs',
      'story.section9': 'Et tout est devenu plus fastoche',
      'story.section10': 'maintenant je suis un peu plus grand',
      'story.section11': 'Dans l\'un de mes projets d\'études, j\'ai fait le choix d\'ouvrir au monde entier ce que mon père avait créé pour m\'aider',
      'story.section12': 'Et ça a donné synesthesia.world',
      'story.section13': 'Parce que nous sommes synesthètes.',
      'story.section14': 'Nous sommes la singularité',
      'story.morphing': 'Emmène moi',
      'login.storyLink': 'comment tout a commencé',
      'blog.subtitle': 'Les oeuvres de nos synesthètes',
      'thecircle.title': 'Votre cercle de couleurs',
      'thecircle.loading': 'Chargement...',
      'thecircle.noMatrix': 'Vous devez d\'abord créer une matrice',
      'thecircle.createMatrix': 'Créer une matrice',
      'thecircle.selectMatrix': 'Sélectionner une matrice :',
      'thecircle.share': 'Partager',
      'thecircle.exportError': 'Erreur lors de l\'export:',
      'dashboard.sectionMatrices': 'Matrices',
      'dashboard.sectionDocuments': 'Documents',
      'dashboard.matriceSubtitle': 'Créez et modifiez votre matrice alphabet-couleurs',
      'dashboard.historySubtitle': 'Consultez l\'historique de vos matrices',
      'dashboard.circleTitle': 'Votre cercle de couleurs',
      'dashboard.circleSubtitle': 'Exporter votre cercle synesthète',
      'dashboard.documentSubtitle': 'Créez un document avec votre dernière matrice',
      'dashboard.documentHistorySubtitle': 'Consultez l\'historique de vos documents',
      'dashboard.animatedDocumentTitle': 'Alphabet animé',
      'dashboard.animatedDocumentSubtitle': 'Créez un document avec un alphabet animé',
      'animatedEditor.title': 'Éditeur de texte animé',
      'animatedEditor.alphabet': 'Alphabet',
      'animatedEditor.letters': 'lettres',
      'animatedEditor.selectAlphabet': 'Sélectionnez un alphabet pour commencer',
      'animatedEditor.typeText': 'Tapez du texte pour voir les animations',
      'animatedEditor.loading': 'Chargement des alphabets...',
      'animatedEditor.placeholder': 'Tapez votre texte ici...',
      'animatedEditor.play': 'Rejouer',
      'animatedEditor.export': 'Export',
    },
  },
  en: {
    translation: {
      'app.title': 'Synestesia',
      'auth.login': 'Login',
      'auth.signup': 'Sign up',
      'auth.email': 'Email',
      'auth.password': 'Password',
      'auth.confirmPassword': 'Confirm password',
      'auth.firstName': 'First name',
      'auth.lastName': 'Last name',
      'auth.language': 'Language',
      'auth.country': 'Country',
      'auth.age': 'Age',
      'auth.submit': 'Submit',
      'auth.logout': 'Logout',
      'auth.rememberMe': 'Remember me',
      'verifyEmail.title': 'Verify your email',
      'verifyEmail.sentTo': 'We have sent a verification link to:',
      'verifyEmail.steps': 'Next steps:',
      'verifyEmail.step1': 'Open your inbox',
      'verifyEmail.step2': 'Click the verification link in the email',
      'verifyEmail.step3': 'Your account will be activated and you can log in',
      'verifyEmail.resend': 'Resend verification email',
      'verifyEmail.sending': 'Sending...',
      'verifyEmail.afterVerify': 'After verifying your email, you can log in.',
      'verifyEmail.goToLogin': 'Go to login page →',
      'verifyEmail.emailNotAvailable': 'Email address not available',
      'verifyEmail.resendSuccess': 'Verification email sent successfully',
      'verifyEmail.resendError': 'Error sending email',
      'emailVerification.loading': 'Verification in progress...',
      'emailVerification.pleaseWait': 'Please wait',
      'emailVerification.success': 'Email verified!',
      'emailVerification.successMessage': 'Your email has been successfully verified.',
      'emailVerification.error': 'Validation error',
      'emailVerification.errorMessage': 'The validation link is invalid or has expired.',
      'emailVerification.loginNow': 'Log in now',
      'emailVerification.goToLogin': 'Go to login',
      'emailVerification.createAccount': 'Create account',
      'emailVerification.missingParams': 'Missing validation parameters.',
      'profile.title': 'My profile',
      'profile.button': 'Profile',
      'profile.loading': 'Loading...',
      'profile.save': 'Save',
      'profile.saving': 'Saving...',
      'profile.saved': '✓ Saved!',
      'profile.emailReadOnly': 'Email cannot be changed',
      'profile.currentInfo': 'Your information',
      'profile.editInfo': 'Edit your information',
      'profile.notFilled': 'Not filled in',
      'profile.saveError': 'Error saving',
      'matrice.title': 'Create matrix',
      'matrice.letters': 'Letters',
      'matrice.specialCharacters': 'Special characters',
      'matrice.numbers': 'Numbers',
      'matrice.days': 'Days of the week',
      'matrice.months': 'Months of the year',
      'matrice.save': 'Save',
      'matrice.loadLast': 'Load last matrix',
      'dashboard.title': 'Dashboard',
      'document.title': 'Document editor',
      'document.new': 'New document',
      'document.save': 'Save',
      'document.exportPDF': 'Export to PDF',
      'document.background': 'Background',
      'document.previewWithColors': 'Preview with colors',
      'document.keyboard': 'Keyboard',
      'document.wordCount': 'words',
      'document.wordCountOne': 'word',
      'document.wordLimitExceeded': 'Word limit of 3000 exceeded.',
      'document.loadError': 'Error loading document',
      'document.saveError': 'Error saving document',
      'documentHistory.title': 'Document history',
      'documentHistory.matrice': 'Matrix',
      'documentHistory.edit': 'Edit',
      'documentHistory.delete': 'Delete',
      'documentHistory.deleting': 'Deleting...',
      'documentHistory.confirmDelete': 'Are you sure you want to delete this document?',
      'documentHistory.deleteError': 'Error deleting document',
      'history.title': 'Matrix history',
      'history.delete': 'Delete',
      'history.edit': 'Edit',
      'history.deleting': 'Deleting...',
      'history.confirmDelete': 'Are you sure you want to delete this matrix?',
      'history.deleteError': 'Error deleting matrix',
      'matrice.loadError': 'Error loading matrix',
      'matrice.saveError': 'Error saving',
      'matrice.update': 'Update',
      'matrice.updating': 'Updating...',
      'matrice.updated': 'Updated!',
      'matrice.back': '← Back',
      'matrice.basicGradient': 'Basic gradient',
      'matrice.random': 'Random',
      'matrice.symbolSelect': 'Choose symbol',
      'matrice.symbolFor': 'Symbol for',
      'matrice.symbolMale': 'Male',
      'matrice.symbolFemale': 'Female',
      'matrice.symbolIndeterminate': 'Indeterminate',
      'matrice.sensationDescribe': 'Describe the feeling of this number',
      'matrice.sensationFor': 'Feeling for',
      'matrice.sensationPlaceholder': 'Describe the feeling of this number',
      'common.cancel': 'Cancel',
      'cookie.message': 'This site uses cookies to enhance your experience.',
      'cookie.accept': 'Accept',
      'cookie.decline': 'Decline',
      'story.section1': 'Hi, I\'m Léo. I\'m Franco-Turkish and I live in Normandy',
      'story.section2': 'Here are my Dad and Ursule',
      'story.section3': 'Two things I like to do: play with colors, and do nothing',
      'story.section4': 'But well... you also have to go to school every morning',
      'story.section5': 'and at school I had some difficulties understanding things that were easy to understand (according to the teacher)',
      'story.section6': 'But luckily my dad is too good at inventing things... so we tried to find solutions',
      'story.section7': 'And that\'s when we realized I was synesthete (even the teacher didn\'t know the word)',
      'story.section8': 'We coded together a system to associate letters and colors',
      'story.section9': 'And everything became easier',
      'story.section10': 'now I\'m a bit older',
      'story.section11': 'In one of my study projects, I chose to open to the whole world what my father had created to help me',
      'story.section12': 'And that gave synesthesia.world',
      'story.section13': 'Because we are synesthetes.',
      'story.section14': 'We are the singularity',
      'story.morphing': 'Take me',
      'login.storyLink': 'how it all began',
      'blog.subtitle': 'Works of our synesthetes',
      'thecircle.title': 'Your color circle',
      'thecircle.loading': 'Loading...',
      'thecircle.noMatrix': 'You must first create a matrix',
      'thecircle.createMatrix': 'Create a matrix',
      'thecircle.selectMatrix': 'Select a matrix:',
      'thecircle.share': 'Share',
      'thecircle.exportError': 'Error during export:',
      'dashboard.sectionMatrices': 'Matrices',
      'dashboard.sectionDocuments': 'Documents',
      'dashboard.matriceSubtitle': 'Create and edit your alphabet-color matrix',
      'dashboard.historySubtitle': 'View your matrix history',
      'dashboard.circleTitle': 'Your color circle',
      'dashboard.circleSubtitle': 'Export your synesthetic circle',
      'dashboard.documentSubtitle': 'Create a document with your last matrix',
      'dashboard.documentHistorySubtitle': 'View your document history',
      'dashboard.animatedDocumentTitle': 'Animated alphabet',
      'dashboard.animatedDocumentSubtitle': 'Create a document with an animated alphabet',
      'animatedEditor.title': 'Animated text editor',
      'animatedEditor.alphabet': 'Alphabet',
      'animatedEditor.letters': 'letters',
      'animatedEditor.selectAlphabet': 'Select an alphabet to start',
      'animatedEditor.typeText': 'Type text to see animations',
      'animatedEditor.loading': 'Loading alphabets...',
      'animatedEditor.placeholder': 'Type your text here...',
      'animatedEditor.play': 'Replay',
      'animatedEditor.export': 'Export',
    },
  },
  es: {
    translation: {
      'app.title': 'Synestesia',
      'auth.login': 'Iniciar sesión',
      'auth.signup': 'Registrarse',
      'auth.email': 'Correo electrónico',
      'auth.password': 'Contraseña',
      'auth.confirmPassword': 'Confirmar contraseña',
      'auth.firstName': 'Nombre',
      'auth.lastName': 'Apellido',
      'auth.language': 'Idioma',
      'auth.country': 'País',
      'auth.age': 'Edad',
      'auth.submit': 'Enviar',
      'auth.logout': 'Cerrar sesión',
      'verifyEmail.title': 'Verifica tu email',
      'verifyEmail.sentTo': 'Hemos enviado un enlace de verificación a:',
      'verifyEmail.steps': 'Próximos pasos:',
      'verifyEmail.step1': 'Abre tu bandeja de entrada',
      'verifyEmail.step2': 'Haz clic en el enlace de verificación en el email',
      'verifyEmail.step3': 'Tu cuenta se activará y podrás iniciar sesión',
      'verifyEmail.resend': 'Reenviar email de verificación',
      'verifyEmail.sending': 'Enviando...',
      'verifyEmail.afterVerify': 'Después de verificar tu email, puedes iniciar sesión.',
      'verifyEmail.goToLogin': 'Ir a la página de inicio de sesión →',
      'verifyEmail.emailNotAvailable': 'Dirección de email no disponible',
      'verifyEmail.resendSuccess': 'Email de verificación reenviado con éxito',
      'verifyEmail.resendError': 'Error al enviar el email',
      'emailVerification.loading': 'Verificación en curso...',
      'emailVerification.pleaseWait': 'Por favor espera',
      'emailVerification.success': '¡Email verificado!',
      'emailVerification.successMessage': 'Tu dirección de email ha sido verificada con éxito.',
      'emailVerification.error': 'Error de validación',
      'emailVerification.errorMessage': 'El enlace de validación es inválido o ha expirado.',
      'emailVerification.loginNow': 'Iniciar sesión ahora',
      'emailVerification.goToLogin': 'Ir al inicio de sesión',
      'emailVerification.createAccount': 'Crear cuenta',
      'emailVerification.missingParams': 'Parámetros de validación faltantes.',
      'matrice.title': 'Crear matriz',
      'matrice.letters': 'Letras',
      'matrice.specialCharacters': 'Caracteres especiales',
      'matrice.numbers': 'Números',
      'matrice.days': 'Días de la semana',
      'matrice.months': 'Meses del año',
      'matrice.save': 'Guardar',
      'matrice.loadLast': 'Cargar última matriz',
      'dashboard.title': 'Panel de control',
      'document.title': 'Editor de documentos',
      'document.new': 'Nuevo documento',
      'document.save': 'Guardar',
      'document.exportPDF': 'Exportar a PDF',
      'document.background': 'Fondo',
      'document.previewWithColors': 'Vista previa con colores',
      'document.keyboard': 'Teclado',
      'document.wordCount': 'palabras',
      'document.wordCountOne': 'palabra',
      'document.wordLimitExceeded': 'Límite de 3000 palabras superado.',
      'document.loadError': 'Error al cargar el documento',
      'document.saveError': 'Error al guardar el documento',
      'documentHistory.title': 'Historial de documentos',
      'documentHistory.matrice': 'Matriz',
      'documentHistory.edit': 'Editar',
      'documentHistory.delete': 'Eliminar',
      'documentHistory.deleting': 'Eliminando...',
      'documentHistory.confirmDelete': '¿Estás seguro de que quieres eliminar este documento?',
      'documentHistory.deleteError': 'Error al eliminar el documento',
      'history.title': 'Historial de matrices',
      'history.edit': 'Editar',
      'history.delete': 'Eliminar',
      'history.confirmDelete': '¿Estás seguro de que quieres eliminar esta matriz?',
      'history.deleteError': 'Error al eliminar',
      'matrice.basicGradient': 'Degradado básico',
      'matrice.random': 'Aleatorio',
      'matrice.symbolSelect': 'Elegir símbolo',
      'matrice.symbolFor': 'Símbolo para',
      'matrice.symbolMale': 'Masculino',
      'matrice.symbolFemale': 'Femenino',
      'matrice.symbolIndeterminate': 'Indeterminado',
      'matrice.sensationDescribe': 'Describir la sensación de este número',
      'matrice.sensationFor': 'Sensación para',
      'matrice.sensationPlaceholder': 'Describa la sensación de este número',
      'common.cancel': 'Cancelar',
      'cookie.message': 'Este sitio utiliza cookies para mejorar su experiencia.',
      'cookie.accept': 'Aceptar',
      'cookie.decline': 'Rechazar',
      'story.section1': 'Hola, soy Léo. Soy franco-turco y vivo en Normandía',
      'story.section2': 'Aquí están mi Papá y Ursule',
      'story.section3': 'Dos cosas que me gusta hacer: jugar con colores y no hacer nada',
      'story.section4': 'Pero bueno... también hay que ir a la escuela todas las mañanas',
      'story.section5': 'y en la escuela tuve algunas dificultades para entender cosas que eran fáciles de entender (según la maestra)',
      'story.section6': 'Pero afortunadamente mi papá es demasiado bueno inventando cosas... así que intentamos encontrar soluciones',
      'story.section7': 'Y ahí fue cuando nos dimos cuenta de que era sinestésico (ni siquiera la maestra conocía la palabra)',
      'story.section8': 'Codificamos juntos un sistema para asociar letras y colores',
      'story.section9': 'Y todo se volvió más fácil',
      'story.section10': 'ahora soy un poco más grande',
      'story.section11': 'En uno de mis proyectos de estudio, elegí abrir al mundo entero lo que mi padre había creado para ayudarme',
      'story.section12': 'Y eso dio synesthesia.world',
      'story.section13': 'Porque somos sinestésicos.',
      'story.section14': 'Somos la singularidad',
      'story.morphing': 'Llévame',
      'login.storyLink': 'cómo comenzó todo',
      'blog.subtitle': 'Obras de nuestros sinestésicos',
      'thecircle.title': 'Tu círculo de colores',
      'thecircle.loading': 'Cargando...',
      'thecircle.noMatrix': 'Primero debes crear una matriz',
      'thecircle.createMatrix': 'Crear una matriz',
      'thecircle.selectMatrix': 'Seleccionar una matriz:',
      'thecircle.share': 'Compartir',
      'thecircle.exportError': 'Error durante la exportación:',
      'dashboard.sectionMatrices': 'Matrices',
      'dashboard.sectionDocuments': 'Documentos',
      'dashboard.matriceSubtitle': 'Crea y edita tu matriz alfabeto-colores',
      'dashboard.historySubtitle': 'Consulta el historial de tus matrices',
      'dashboard.circleTitle': 'Tu círculo de colores',
      'dashboard.circleSubtitle': 'Exporta tu círculo sinestésico',
      'dashboard.documentSubtitle': 'Crea un documento con tu última matriz',
      'dashboard.documentHistorySubtitle': 'Consulta el historial de tus documentos',
      'dashboard.animatedDocumentTitle': 'Alfabeto animado',
      'dashboard.animatedDocumentSubtitle': 'Crea un documento con un alfabeto animado',
      'animatedEditor.title': 'Editor de texto animado',
      'animatedEditor.alphabet': 'Alfabeto',
      'animatedEditor.letters': 'letras',
      'animatedEditor.selectAlphabet': 'Selecciona un alfabeto para comenzar',
      'animatedEditor.typeText': 'Escribe texto para ver las animaciones',
      'animatedEditor.loading': 'Cargando alfabetos...',
      'animatedEditor.placeholder': 'Escribe tu texto aquí...',
      'animatedEditor.play': 'Reproducir',
    },
  },
  pt: {
    translation: {
      'app.title': 'Synestesia',
      'auth.login': 'Entrar',
      'auth.signup': 'Registrar',
      'auth.email': 'Email',
      'auth.password': 'Senha',
      'auth.confirmPassword': 'Confirmar senha',
      'auth.firstName': 'Nome',
      'auth.lastName': 'Sobrenome',
      'auth.language': 'Idioma',
      'auth.country': 'País',
      'auth.age': 'Idade',
      'auth.submit': 'Enviar',
      'auth.logout': 'Sair',
      'verifyEmail.title': 'Verifique seu email',
      'verifyEmail.sentTo': 'Enviamos um link de verificação para:',
      'verifyEmail.steps': 'Próximos passos:',
      'verifyEmail.step1': 'Abra sua caixa de entrada',
      'verifyEmail.step2': 'Clique no link de verificação no email',
      'verifyEmail.step3': 'Sua conta será ativada e você poderá fazer login',
      'verifyEmail.resend': 'Reenviar email de verificação',
      'verifyEmail.sending': 'Enviando...',
      'verifyEmail.afterVerify': 'Após verificar seu email, você pode fazer login.',
      'verifyEmail.goToLogin': 'Ir para a página de login →',
      'verifyEmail.emailNotAvailable': 'Endereço de email não disponível',
      'verifyEmail.resendSuccess': 'Email de verificação reenviado com sucesso',
      'verifyEmail.resendError': 'Erro ao enviar o email',
      'emailVerification.loading': 'Verificação em andamento...',
      'emailVerification.pleaseWait': 'Por favor aguarde',
      'emailVerification.success': 'Email verificado!',
      'emailVerification.successMessage': 'Seu email foi verificado com sucesso.',
      'emailVerification.error': 'Erro de validação',
      'emailVerification.errorMessage': 'O link de validação é inválido ou expirou.',
      'emailVerification.loginNow': 'Fazer login agora',
      'emailVerification.goToLogin': 'Ir para o login',
      'emailVerification.createAccount': 'Criar conta',
      'emailVerification.missingParams': 'Parâmetros de validação ausentes.',
      'matrice.title': 'Criar matriz',
      'matrice.letters': 'Letras',
      'matrice.specialCharacters': 'Caracteres especiales',
      'matrice.numbers': 'Números',
      'matrice.days': 'Días de la semana',
      'matrice.months': 'Meses del año',
      'matrice.save': 'Salvar',
      'matrice.loadLast': 'Carregar última matriz',
      'dashboard.title': 'Painel de controle',
      'document.title': 'Editor de documentos',
      'document.new': 'Novo documento',
      'document.save': 'Salvar',
      'document.exportPDF': 'Exportar para PDF',
      'document.background': 'Fundo',
      'document.previewWithColors': 'Visualização com cores',
      'document.keyboard': 'Teclado',
      'document.wordCount': 'palavras',
      'document.wordCountOne': 'palavra',
      'document.wordLimitExceeded': 'Limite de 3000 palavras excedido.',
      'document.loadError': 'Erro ao carregar o documento',
      'document.saveError': 'Erro ao salvar o documento',
      'documentHistory.title': 'Histórico de documentos',
      'documentHistory.matrice': 'Matriz',
      'documentHistory.edit': 'Editar',
      'documentHistory.delete': 'Excluir',
      'documentHistory.deleting': 'Excluindo...',
      'documentHistory.confirmDelete': 'Tem certeza de que deseja excluir este documento?',
      'documentHistory.deleteError': 'Erro ao excluir o documento',
      'history.title': 'Histórico de matrizes',
      'history.edit': 'Editar',
      'history.delete': 'Excluir',
      'history.confirmDelete': 'Tem certeza de que deseja excluir esta matriz?',
      'history.deleteError': 'Erro ao excluir',
      'matrice.basicGradient': 'Gradiente básico',
      'matrice.random': 'Aleatório',
      'matrice.symbolSelect': 'Escolher símbolo',
      'matrice.symbolFor': 'Símbolo para',
      'matrice.symbolMale': 'Masculino',
      'matrice.symbolFemale': 'Feminino',
      'matrice.symbolIndeterminate': 'Indeterminado',
      'matrice.sensationDescribe': 'Descrever a sensação deste número',
      'matrice.sensationFor': 'Sensação para',
      'matrice.sensationPlaceholder': 'Descreva a sensação deste número',
      'common.cancel': 'Cancelar',
      'cookie.message': 'Este site usa cookies para melhorar sua experiência.',
      'cookie.accept': 'Aceitar',
      'cookie.decline': 'Recusar',
      'story.section1': 'Oi, eu sou Léo. Sou franco-turco e moro na Normandia',
      'story.section2': 'Aqui estão meu Pai e Ursule',
      'story.section3': 'Duas coisas que gosto de fazer: brincar com cores e não fazer nada',
      'story.section4': 'Mas bem... também é preciso ir à escola todas as manhãs',
      'story.section5': 'e na escola tive algumas dificuldades para entender coisas que eram fáceis de entender (segundo a professora)',
      'story.section6': 'Mas felizmente meu pai é muito bom em inventar coisas... então tentamos encontrar soluções',
      'story.section7': 'E foi aí que percebemos que eu era sinestésico (nem mesmo a professora conhecia a palavra)',
      'story.section8': 'Codificamos juntos um sistema para associar letras e cores',
      'story.section9': 'E tudo ficou mais fácil',
      'story.section10': 'agora estou um pouco mais velho',
      'story.section11': 'Em um dos meus projetos de estudo, escolhi abrir para o mundo inteiro o que meu pai havia criado para me ajudar',
      'story.section12': 'E isso deu synesthesia.world',
      'story.section13': 'Porque somos sinestésicos.',
      'story.section14': 'Somos a singularidade',
      'story.morphing': 'Leve-me',
      'login.storyLink': 'como tudo começou',
      'blog.subtitle': 'Obras dos nossos sinestésicos',
      'thecircle.title': 'Seu círculo de cores',
      'thecircle.loading': 'Carregando...',
      'thecircle.noMatrix': 'Você deve primeiro criar uma matriz',
      'thecircle.createMatrix': 'Criar uma matriz',
      'thecircle.selectMatrix': 'Selecionar uma matriz:',
      'thecircle.share': 'Compartilhar',
      'thecircle.exportError': 'Erro durante a exportação:',
      'dashboard.sectionMatrices': 'Matrizes',
      'dashboard.sectionDocuments': 'Documentos',
      'dashboard.matriceSubtitle': 'Crie e edite sua matriz alfabeto-cores',
      'dashboard.historySubtitle': 'Consulte o histórico de suas matrizes',
      'dashboard.circleTitle': 'Seu círculo de cores',
      'dashboard.circleSubtitle': 'Exportar seu círculo sinestésico',
      'dashboard.documentSubtitle': 'Crie um documento com sua última matriz',
      'dashboard.documentHistorySubtitle': 'Consulte o histórico de seus documentos',
      'dashboard.animatedDocumentTitle': 'Alfabeto animado',
      'dashboard.animatedDocumentSubtitle': 'Crie um documento com um alfabeto animado',
      'animatedEditor.title': 'Editor de texto animado',
      'animatedEditor.alphabet': 'Alfabeto',
      'animatedEditor.letters': 'letras',
      'animatedEditor.selectAlphabet': 'Selecione um alfabeto para começar',
      'animatedEditor.typeText': 'Digite texto para ver as animações',
      'animatedEditor.loading': 'Carregando alfabetos...',
      'animatedEditor.placeholder': 'Digite seu texto aqui...',
      'animatedEditor.play': 'Reproduzir',
    },
  },
  de: {
    translation: {
      'app.title': 'Synestesia',
      'auth.login': 'Anmelden',
      'auth.signup': 'Registrieren',
      'auth.email': 'E-Mail',
      'auth.password': 'Passwort',
      'auth.confirmPassword': 'Passwort bestätigen',
      'auth.firstName': 'Vorname',
      'auth.lastName': 'Nachname',
      'auth.language': 'Sprache',
      'auth.country': 'Land',
      'auth.age': 'Alter',
      'auth.submit': 'Absenden',
      'auth.logout': 'Abmelden',
      'verifyEmail.title': 'Überprüfen Sie Ihre E-Mail',
      'verifyEmail.sentTo': 'Wir haben einen Bestätigungslink gesendet an:',
      'verifyEmail.steps': 'Nächste Schritte:',
      'verifyEmail.step1': 'Öffnen Sie Ihren Posteingang',
      'verifyEmail.step2': 'Klicken Sie auf den Bestätigungslink in der E-Mail',
      'verifyEmail.step3': 'Ihr Konto wird aktiviert und Sie können sich anmelden',
      'verifyEmail.resend': 'Bestätigungs-E-Mail erneut senden',
      'verifyEmail.sending': 'Wird gesendet...',
      'verifyEmail.afterVerify': 'Nach der E-Mail-Bestätigung können Sie sich anmelden.',
      'verifyEmail.goToLogin': 'Zur Anmeldeseite →',
      'verifyEmail.emailNotAvailable': 'E-Mail-Adresse nicht verfügbar',
      'verifyEmail.resendSuccess': 'Bestätigungs-E-Mail erfolgreich gesendet',
      'verifyEmail.resendError': 'Fehler beim Senden der E-Mail',
      'emailVerification.loading': 'Überprüfung läuft...',
      'emailVerification.pleaseWait': 'Bitte warten',
      'emailVerification.success': 'E-Mail bestätigt!',
      'emailVerification.successMessage': 'Ihre E-Mail-Adresse wurde erfolgreich bestätigt.',
      'emailVerification.error': 'Validierungsfehler',
      'emailVerification.errorMessage': 'Der Bestätigungslink ist ungültig oder abgelaufen.',
      'emailVerification.loginNow': 'Jetzt anmelden',
      'emailVerification.goToLogin': 'Zur Anmeldung',
      'emailVerification.createAccount': 'Konto erstellen',
      'emailVerification.missingParams': 'Validierungsparameter fehlen.',
      'matrice.title': 'Matrix erstellen',
      'matrice.letters': 'Buchstaben',
      'matrice.specialCharacters': 'Sonderzeichen',
      'matrice.numbers': 'Zahlen',
      'matrice.days': 'Wochentage',
      'matrice.months': 'Monate des Jahres',
      'matrice.save': 'Speichern',
      'matrice.loadLast': 'Letzte Matrix laden',
      'dashboard.title': 'Instrumententafel',
      'document.title': 'Dokumenteditor',
      'document.new': 'Neues Dokument',
      'document.save': 'Speichern',
      'document.exportPDF': 'Als PDF exportieren',
      'document.background': 'Hintergrund',
      'document.previewWithColors': 'Vorschau mit Farben',
      'document.keyboard': 'Tastatur',
      'document.wordCount': 'Wörter',
      'document.wordCountOne': 'Wort',
      'document.wordLimitExceeded': 'Wortlimit von 3000 überschritten.',
      'document.loadError': 'Fehler beim Laden des Dokuments',
      'document.saveError': 'Fehler beim Speichern des Dokuments',
      'documentHistory.title': 'Dokumentverlauf',
      'documentHistory.matrice': 'Matrix',
      'documentHistory.edit': 'Bearbeiten',
      'documentHistory.delete': 'Löschen',
      'documentHistory.deleting': 'Löschen...',
      'documentHistory.confirmDelete': 'Möchten Sie dieses Dokument wirklich löschen?',
      'documentHistory.deleteError': 'Fehler beim Löschen des Dokuments',
      'history.title': 'Matrix-Verlauf',
      'history.edit': 'Bearbeiten',
      'history.delete': 'Löschen',
      'history.confirmDelete': 'Möchten Sie diese Matrix wirklich löschen?',
      'history.deleteError': 'Fehler beim Löschen',
      'matrice.basicGradient': 'Basisverlauf',
      'matrice.random': 'Zufall',
      'matrice.symbolSelect': 'Symbol wählen',
      'matrice.symbolFor': 'Symbol für',
      'matrice.symbolMale': 'Männlich',
      'matrice.symbolFemale': 'Weiblich',
      'matrice.symbolIndeterminate': 'Unbestimmt',
      'matrice.sensationDescribe': 'Das Gefühl dieser Zahl beschreiben',
      'matrice.sensationFor': 'Gefühl für',
      'matrice.sensationPlaceholder': 'Beschreiben Sie das Gefühl dieser Zahl',
      'common.cancel': 'Abbrechen',
      'cookie.message': 'Diese Website verwendet Cookies, um Ihre Erfahrung zu verbessern.',
      'cookie.accept': 'Akzeptieren',
      'cookie.decline': 'Ablehnen',
      'story.section1': 'Hallo, ich bin Léo. Ich bin französisch-türkisch und lebe in der Normandie',
      'story.section2': 'Hier sind mein Papa und Ursule',
      'story.section3': 'Zwei Dinge, die ich gerne tue: mit Farben spielen und nichts tun',
      'story.section4': 'Aber nun... man muss auch jeden Morgen zur Schule gehen',
      'story.section5': 'und in der Schule hatte ich einige Schwierigkeiten, Dinge zu verstehen, die leicht zu verstehen waren (laut der Lehrerin)',
      'story.section6': 'Aber zum Glück ist mein Papa zu gut darin, Dinge zu erfinden... also haben wir versucht, Lösungen zu finden',
      'story.section7': 'Und da haben wir festgestellt, dass ich synästhetisch bin (sogar die Lehrerin kannte das Wort nicht)',
      'story.section8': 'Wir haben zusammen ein System programmiert, um Buchstaben und Farben zu assoziieren',
      'story.section9': 'Und alles wurde einfacher',
      'story.section10': 'jetzt bin ich ein bisschen älter',
      'story.section11': 'In einem meiner Studienprojekte habe ich mich entschieden, der ganzen Welt zu öffnen, was mein Vater geschaffen hatte, um mir zu helfen',
      'story.section12': 'Und das ergab synesthesia.world',
      'story.section13': 'Weil wir Synästhetiker sind.',
      'story.section14': 'Wir sind die Singularität',
      'story.morphing': 'Nimm mich mit',
      'login.storyLink': 'wie alles begann',
      'blog.subtitle': 'Werke unserer Synästhetiker',
      'thecircle.title': 'Ihr Farbkreis',
      'thecircle.loading': 'Laden...',
      'thecircle.noMatrix': 'Sie müssen zuerst eine Matrix erstellen',
      'thecircle.createMatrix': 'Matrix erstellen',
      'thecircle.selectMatrix': 'Matrix auswählen:',
      'thecircle.share': 'Teilen',
      'thecircle.exportError': 'Fehler beim Export:',
      'dashboard.sectionMatrices': 'Matrizen',
      'dashboard.sectionDocuments': 'Dokumente',
      'dashboard.matriceSubtitle': 'Erstellen und bearbeiten Sie Ihre Alphabet-Farb-Matrix',
      'dashboard.historySubtitle': 'Sehen Sie sich Ihren Matrix-Verlauf an',
      'dashboard.circleTitle': 'Ihr Farbkreis',
      'dashboard.circleSubtitle': 'Exportieren Sie Ihren synästhetischen Kreis',
      'dashboard.documentSubtitle': 'Erstellen Sie ein Dokument mit Ihrer letzten Matrix',
      'dashboard.documentHistorySubtitle': 'Sehen Sie sich Ihren Dokumentverlauf an',
      'dashboard.animatedDocumentTitle': 'Animiertes Alphabet',
      'dashboard.animatedDocumentSubtitle': 'Erstellen Sie ein Dokument mit einem animierten Alphabet',
      'animatedEditor.title': 'Animierter Texteditor',
      'animatedEditor.alphabet': 'Alphabet',
      'animatedEditor.letters': 'Buchstaben',
      'animatedEditor.selectAlphabet': 'Wählen Sie ein Alphabet aus, um zu beginnen',
      'animatedEditor.typeText': 'Geben Sie Text ein, um Animationen zu sehen',
      'animatedEditor.loading': 'Alphabete werden geladen...',
      'animatedEditor.placeholder': 'Geben Sie Ihren Text hier ein...',
      'animatedEditor.play': 'Wiedergabe',
    },
  },
  it: {
    translation: {
      'app.title': 'Synestesia',
      'auth.login': 'Accedi',
      'auth.signup': 'Registrati',
      'auth.email': 'Email',
      'auth.password': 'Password',
      'auth.confirmPassword': 'Conferma password',
      'auth.firstName': 'Nome',
      'auth.lastName': 'Cognome',
      'auth.language': 'Lingua',
      'auth.country': 'Paese',
      'auth.age': 'Età',
      'auth.submit': 'Invia',
      'auth.logout': 'Esci',
      'verifyEmail.title': 'Verifica la tua email',
      'verifyEmail.sentTo': 'Abbiamo inviato un link di verifica a:',
      'verifyEmail.steps': 'Prossimi passi:',
      'verifyEmail.step1': 'Apri la tua casella di posta',
      'verifyEmail.step2': 'Clicca sul link di verifica nell\'email',
      'verifyEmail.step3': 'Il tuo account sarà attivato e potrai accedere',
      'verifyEmail.resend': 'Reinvia email di verifica',
      'verifyEmail.sending': 'Invio in corso...',
      'verifyEmail.afterVerify': 'Dopo aver verificato la tua email, puoi accedere.',
      'verifyEmail.goToLogin': 'Vai alla pagina di accesso →',
      'verifyEmail.emailNotAvailable': 'Indirizzo email non disponibile',
      'verifyEmail.resendSuccess': 'Email di verifica reinviata con successo',
      'verifyEmail.resendError': 'Errore durante l\'invio dell\'email',
      'emailVerification.loading': 'Verifica in corso...',
      'emailVerification.pleaseWait': 'Attendere prego',
      'emailVerification.success': 'Email verificata!',
      'emailVerification.successMessage': 'Il tuo indirizzo email è stato verificato con successo.',
      'emailVerification.error': 'Errore di validazione',
      'emailVerification.errorMessage': 'Il link di verifica non è valido o è scaduto.',
      'emailVerification.loginNow': 'Accedi ora',
      'emailVerification.goToLogin': 'Vai all\'accesso',
      'emailVerification.createAccount': 'Crea account',
      'emailVerification.missingParams': 'Parametri di validazione mancanti.',
      'matrice.title': 'Crea matrice',
      'matrice.letters': 'Lettere',
      'matrice.specialCharacters': 'Caratteri speciali',
      'matrice.numbers': 'Numeri',
      'matrice.days': 'Giorni della settimana',
      'matrice.months': 'Mesi dell\'anno',
      'matrice.save': 'Salva',
      'matrice.loadLast': 'Carica ultima matrice',
      'dashboard.title': 'Pannello di controllo',
      'document.title': 'Editor documenti',
      'document.new': 'Nuovo documento',
      'document.save': 'Salva',
      'document.exportPDF': 'Esporta in PDF',
      'document.background': 'Sfondo',
      'document.previewWithColors': 'Anteprima con colori',
      'document.keyboard': 'Tastiera',
      'document.wordCount': 'parole',
      'document.wordCountOne': 'parola',
      'document.wordLimitExceeded': 'Limite di 3000 parole superato.',
      'document.loadError': 'Errore durante il caricamento del documento',
      'document.saveError': 'Errore durante il salvataggio del documento',
      'documentHistory.title': 'Cronologia documenti',
      'documentHistory.matrice': 'Matrice',
      'documentHistory.edit': 'Modifica',
      'documentHistory.delete': 'Elimina',
      'documentHistory.deleting': 'Eliminazione...',
      'documentHistory.confirmDelete': 'Sei sicuro di voler eliminare questo documento?',
      'documentHistory.deleteError': 'Errore durante l\'eliminazione del documento',
      'history.title': 'Cronologia matrici',
      'history.edit': 'Modifica',
      'history.delete': 'Elimina',
      'history.confirmDelete': 'Sei sicuro di voler eliminare questa matrice?',
      'history.deleteError': 'Errore durante l\'eliminazione',
      'matrice.basicGradient': 'Gradiente base',
      'matrice.random': 'Casuale',
      'matrice.symbolSelect': 'Scegli simbolo',
      'matrice.symbolFor': 'Simbolo per',
      'matrice.symbolMale': 'Maschio',
      'matrice.symbolFemale': 'Femmina',
      'matrice.symbolIndeterminate': 'Indeterminato',
      'matrice.sensationDescribe': 'Descrivere la sensazione di questo numero',
      'matrice.sensationFor': 'Sensazione per',
      'matrice.sensationPlaceholder': 'Descrivi la sensazione di questo numero',
      'common.cancel': 'Annulla',
      'cookie.message': 'Questo sito utilizza i cookie per migliorare la tua esperienza.',
      'cookie.accept': 'Accetta',
      'cookie.decline': 'Rifiuta',
      'story.section1': 'Ciao, sono Léo. Sono franco-turco e vivo in Normandia',
      'story.section2': 'Ecco mio Papà e Ursule',
      'story.section3': 'Due cose che mi piace fare: giocare con i colori e non fare niente',
      'story.section4': 'Ma beh... bisogna anche andare a scuola tutte le mattine',
      'story.section5': 'e a scuola ho avuto alcune difficoltà a capire cose che erano facili da capire (secondo la maestra)',
      'story.section6': 'Ma fortunatamente mio papà è troppo bravo a inventare cose... quindi abbiamo provato a trovare soluzioni',
      'story.section7': 'Ed è lì che abbiamo realizzato che ero sinestetico (nemmeno la maestra conosceva la parola)',
      'story.section8': 'Abbiamo codificato insieme un sistema per associare lettere e colori',
      'story.section9': 'E tutto è diventato più facile',
      'story.section10': 'ora sono un po\' più grande',
      'story.section11': 'In uno dei miei progetti di studio, ho scelto di aprire al mondo intero ciò che mio padre aveva creato per aiutarmi',
      'story.section12': 'E questo ha dato synesthesia.world',
      'story.section13': 'Perché siamo sinestetici.',
      'story.section14': 'Siamo la singolarità',
      'story.morphing': 'Portami',
      'login.storyLink': 'come è iniziato tutto',
      'blog.subtitle': 'Opere dei nostri sinestetici',
      'thecircle.title': 'Il tuo cerchio di colori',
      'thecircle.loading': 'Caricamento...',
      'thecircle.noMatrix': 'Devi prima creare una matrice',
      'thecircle.createMatrix': 'Crea una matrice',
      'thecircle.selectMatrix': 'Seleziona una matrice:',
      'thecircle.share': 'Condividi',
      'thecircle.exportError': 'Errore durante l\'esportazione:',
      'dashboard.sectionMatrices': 'Matrici',
      'dashboard.sectionDocuments': 'Documenti',
      'dashboard.matriceSubtitle': 'Crea e modifica la tua matrice alfabeto-colori',
      'dashboard.historySubtitle': 'Consulta la cronologia delle tue matrici',
      'dashboard.circleTitle': 'Il tuo cerchio di colori',
      'dashboard.circleSubtitle': 'Esporta il tuo cerchio sinestetico',
      'dashboard.documentSubtitle': 'Crea un documento con la tua ultima matrice',
      'dashboard.documentHistorySubtitle': 'Consulta la cronologia dei tuoi documenti',
      'dashboard.animatedDocumentTitle': 'Documento con alfabeto animato',
      'dashboard.animatedDocumentSubtitle': 'Crea un documento con un alfabeto animato',
    },
  },
  tr: {
    translation: {
      'app.title': 'Synestesia',
      'auth.login': 'Giriş',
      'auth.signup': 'Kayıt ol',
      'auth.email': 'E-posta',
      'auth.password': 'Şifre',
      'auth.confirmPassword': 'Şifreyi onayla',
      'auth.firstName': 'Ad',
      'auth.lastName': 'Soyad',
      'auth.language': 'Dil',
      'auth.country': 'Ülke',
      'auth.age': 'Yaş',
      'auth.submit': 'Gönder',
      'auth.logout': 'Çıkış',
      'verifyEmail.title': 'E-postanızı doğrulayın',
      'verifyEmail.sentTo': 'Doğrulama bağlantısını şu adrese gönderdik:',
      'verifyEmail.steps': 'Sonraki adımlar:',
      'verifyEmail.step1': 'Gelen kutunuzu açın',
      'verifyEmail.step2': 'E-postadaki doğrulama bağlantısına tıklayın',
      'verifyEmail.step3': 'Hesabınız etkinleştirilecek ve giriş yapabileceksiniz',
      'verifyEmail.resend': 'Doğrulama e-postasını tekrar gönder',
      'verifyEmail.sending': 'Gönderiliyor...',
      'verifyEmail.afterVerify': 'E-postanızı doğruladıktan sonra giriş yapabilirsiniz.',
      'verifyEmail.goToLogin': 'Giriş sayfasına git →',
      'verifyEmail.emailNotAvailable': 'E-posta adresi mevcut değil',
      'verifyEmail.resendSuccess': 'Doğrulama e-postası başarıyla gönderildi',
      'verifyEmail.resendError': 'E-posta gönderilirken hata',
      'emailVerification.loading': 'Doğrulama devam ediyor...',
      'emailVerification.pleaseWait': 'Lütfen bekleyin',
      'emailVerification.success': 'E-posta doğrulandı!',
      'emailVerification.successMessage': 'E-posta adresiniz başarıyla doğrulandı.',
      'emailVerification.error': 'Doğrulama hatası',
      'emailVerification.errorMessage': 'Doğrulama bağlantısı geçersiz veya süresi dolmuş.',
      'emailVerification.loginNow': 'Şimdi giriş yap',
      'emailVerification.goToLogin': 'Girişe git',
      'emailVerification.createAccount': 'Hesap oluştur',
      'emailVerification.missingParams': 'Doğrulama parametreleri eksik.',
      'matrice.title': 'Matris oluştur',
      'matrice.letters': 'Harfler',
      'matrice.specialCharacters': 'Özel karakterler',
      'matrice.numbers': 'Sayılar',
      'matrice.days': 'Haftanın günleri',
      'matrice.months': 'Yılın ayları',
      'matrice.save': 'Kaydet',
      'matrice.loadLast': 'Son matrisi yükle',
      'dashboard.title': 'Kontrol paneli',
      'document.title': 'Belge düzenleyici',
      'document.new': 'Yeni belge',
      'document.save': 'Kaydet',
      'document.exportPDF': 'PDF olarak dışa aktar',
      'document.background': 'Arka plan',
      'document.previewWithColors': 'Renkli önizleme',
      'document.keyboard': 'Klavye',
      'document.wordCount': 'kelime',
      'document.wordCountOne': 'kelime',
      'document.wordLimitExceeded': '3000 kelime sınırı aşıldı.',
      'document.loadError': 'Belge yüklenirken hata',
      'document.saveError': 'Belge kaydedilirken hata',
      'documentHistory.title': 'Belge geçmişi',
      'documentHistory.matrice': 'Matris',
      'documentHistory.edit': 'Düzenle',
      'documentHistory.delete': 'Sil',
      'documentHistory.deleting': 'Siliniyor...',
      'documentHistory.confirmDelete': 'Bu belgeyi silmek istediğinizden emin misiniz?',
      'documentHistory.deleteError': 'Belge silinirken hata',
      'history.title': 'Matris geçmişi',
      'history.edit': 'Düzenle',
      'history.delete': 'Sil',
      'history.confirmDelete': 'Bu matrisi silmek istediğinizden emin misiniz?',
      'history.deleteError': 'Silme hatası',
      'matrice.basicGradient': 'Temel gradyan',
      'matrice.random': 'Rastgele',
      'matrice.symbolSelect': 'Sembol seç',
      'matrice.symbolFor': 'Sembol',
      'matrice.symbolMale': 'Erkek',
      'matrice.symbolFemale': 'Dişi',
      'matrice.symbolIndeterminate': 'Belirsiz',
      'matrice.sensationDescribe': 'Bu sayının hissini tanımlayın',
      'matrice.sensationFor': 'Hissi',
      'matrice.sensationPlaceholder': 'Bu sayının hissini tanımlayın',
      'common.cancel': 'İptal',
      'cookie.message': 'Bu site deneyiminizi geliştirmek için çerezler kullanır.',
      'cookie.accept': 'Kabul et',
      'cookie.decline': 'Reddet',
      'story.section1': 'Merhaba, ben Léo. Ben Franco-Türküm ve Normandiya\'da yaşıyorum',
      'story.section2': 'İşte Babam ve Ursule',
      'story.section3': 'Yapmayı sevdiğim iki şey: renklerle oynamak ve hiçbir şey yapmamak',
      'story.section4': 'Ama işte... her sabah okula da gitmek gerekiyor',
      'story.section5': 've okulda anlaması kolay olan şeyleri anlamakta bazı zorluklar yaşadım (öğretmene göre)',
      'story.section6': 'Ama neyse ki babam bir şeyler icat etmede çok iyi... bu yüzden çözümler bulmaya çalıştık',
      'story.section7': 'Ve işte o zaman sinestetik olduğumu fark ettik (öğretmen bile kelimeyi bilmiyordu)',
      'story.section8': 'Birlikte harfler ve renkleri ilişkilendirmek için bir sistem kodladık',
      'story.section9': 'Ve her şey daha kolay hale geldi',
      'story.section10': 'şimdi biraz daha büyüğüm',
      'story.section11': 'Çalışma projelerimden birinde, babamın bana yardım etmek için yarattığı şeyi tüm dünyaya açmayı seçtim',
      'story.section12': 'Ve bu synesthesia.world\'ü verdi',
      'story.section13': 'Çünkü biz sinestetikiz.',
      'story.section14': 'Biz tekillikiz',
      'story.morphing': 'Beni götür',
      'login.storyLink': 'nasıl başladı',
      'blog.subtitle': 'Sinesteziklerimizin eserleri',
      'thecircle.title': 'Renk çemberiniz',
      'thecircle.loading': 'Yükleniyor...',
      'thecircle.noMatrix': 'Önce bir matris oluşturmalısınız',
      'thecircle.createMatrix': 'Matris oluştur',
      'thecircle.selectMatrix': 'Bir matris seçin:',
      'thecircle.share': 'Paylaş',
      'thecircle.exportError': 'Dışa aktarma hatası:',
      'dashboard.sectionMatrices': 'Matrisler',
      'dashboard.sectionDocuments': 'Belgeler',
      'dashboard.matriceSubtitle': 'Alfabe-renk matrisinizi oluşturun ve düzenleyin',
      'dashboard.historySubtitle': 'Matris geçmişinizi görüntüleyin',
      'dashboard.circleTitle': 'Renk çemberiniz',
      'dashboard.circleSubtitle': 'Sinestetik çemberinizi dışa aktarın',
      'dashboard.documentSubtitle': 'Son matrisinizle bir belge oluşturun',
      'dashboard.documentHistorySubtitle': 'Belge geçmişinizi görüntüleyin',
      'dashboard.animatedDocumentTitle': 'Animasyonlu alfabe',
      'dashboard.animatedDocumentSubtitle': 'Animasyonlu bir alfabe ile belge oluşturun',
      'animatedEditor.title': 'Animasyonlu metin editörü',
      'animatedEditor.alphabet': 'Alfabe',
      'animatedEditor.letters': 'harf',
      'animatedEditor.selectAlphabet': 'Başlamak için bir alfabe seçin',
      'animatedEditor.typeText': 'Animasyonları görmek için metin yazın',
      'animatedEditor.loading': 'Alfabeler yükleniyor...',
      'animatedEditor.placeholder': 'Metninizi buraya yazın...',
    },
  },
  pl: {
    translation: {
      'app.title': 'Synestesia',
      'auth.login': 'Zaloguj się',
      'auth.signup': 'Zarejestruj się',
      'auth.email': 'Email',
      'auth.password': 'Hasło',
      'auth.confirmPassword': 'Potwierdź hasło',
      'auth.firstName': 'Imię',
      'auth.lastName': 'Nazwisko',
      'auth.language': 'Język',
      'auth.country': 'Kraj',
      'auth.age': 'Wiek',
      'auth.submit': 'Wyślij',
      'auth.logout': 'Wyloguj',
      'verifyEmail.title': 'Zweryfikuj swój email',
      'verifyEmail.sentTo': 'Wysłaliśmy link weryfikacyjny na adres:',
      'verifyEmail.steps': 'Następne kroki:',
      'verifyEmail.step1': 'Otwórz swoją skrzynkę odbiorczą',
      'verifyEmail.step2': 'Kliknij link weryfikacyjny w e-mailu',
      'verifyEmail.step3': 'Twoje konto zostanie aktywowane i będziesz mógł się zalogować',
      'verifyEmail.resend': 'Wyślij ponownie email weryfikacyjny',
      'verifyEmail.sending': 'Wysyłanie...',
      'verifyEmail.afterVerify': 'Po weryfikacji emaila możesz się zalogować.',
      'verifyEmail.goToLogin': 'Przejdź do strony logowania →',
      'verifyEmail.emailNotAvailable': 'Adres email niedostępny',
      'verifyEmail.resendSuccess': 'Email weryfikacyjny wysłany pomyślnie',
      'verifyEmail.resendError': 'Błąd podczas wysyłania emaila',
      'emailVerification.loading': 'Weryfikacja w toku...',
      'emailVerification.pleaseWait': 'Proszę czekać',
      'emailVerification.success': 'Email zweryfikowany!',
      'emailVerification.successMessage': 'Twój adres email został pomyślnie zweryfikowany.',
      'emailVerification.error': 'Błąd weryfikacji',
      'emailVerification.errorMessage': 'Link weryfikacyjny jest nieprawidłowy lub wygasł.',
      'emailVerification.loginNow': 'Zaloguj się teraz',
      'emailVerification.goToLogin': 'Przejdź do logowania',
      'emailVerification.createAccount': 'Utwórz konto',
      'emailVerification.missingParams': 'Brakujące parametry weryfikacji.',
      'matrice.title': 'Utwórz macierz',
      'matrice.letters': 'Litery',
      'matrice.specialCharacters': 'Znaki specjalne',
      'matrice.numbers': 'Liczby',
      'matrice.days': 'Dni tygodnia',
      'matrice.months': 'Miesiące roku',
      'matrice.save': 'Zapisz',
      'matrice.loadLast': 'Załaduj ostatnią macierz',
      'dashboard.title': 'Pulpit',
      'document.title': 'Edytor dokumentów',
      'document.new': 'Nowy dokument',
      'document.save': 'Zapisz',
      'document.background': 'Tło',
      'document.previewWithColors': 'Podgląd z kolorami',
      'document.keyboard': 'Klawiatura',
      'document.wordCount': 'słów',
      'document.wordCountOne': 'słowo',
      'document.exportPDF': 'Eksportuj do PDF',
      'document.wordLimitExceeded': 'Przekroczono limit 3000 słów.',
      'document.loadError': 'Błąd podczas ładowania dokumentu',
      'document.saveError': 'Błąd podczas zapisywania dokumentu',
      'documentHistory.title': 'Historia dokumentów',
      'documentHistory.matrice': 'Macierz',
      'documentHistory.edit': 'Edytuj',
      'documentHistory.delete': 'Usuń',
      'documentHistory.deleting': 'Usuwanie...',
      'documentHistory.confirmDelete': 'Czy na pewno chcesz usunąć ten dokument?',
      'documentHistory.deleteError': 'Błąd podczas usuwania dokumentu',
      'history.title': 'Historia macierzy',
      'history.edit': 'Edytuj',
      'history.delete': 'Usuń',
      'history.confirmDelete': 'Czy na pewno chcesz usunąć tę macierz?',
      'history.deleteError': 'Błąd podczas usuwania',
      'matrice.basicGradient': 'Podstawowy gradient',
      'matrice.random': 'Losowo',
      'matrice.symbolSelect': 'Wybierz symbol',
      'matrice.symbolFor': 'Symbol dla',
      'matrice.symbolMale': 'Męski',
      'matrice.symbolFemale': 'Żeński',
      'matrice.symbolIndeterminate': 'Nieokreślony',
      'matrice.sensationDescribe': 'Opisz uczucie tej liczby',
      'matrice.sensationFor': 'Uczucie dla',
      'matrice.sensationPlaceholder': 'Opisz uczucie tej liczby',
      'common.cancel': 'Anuluj',
      'cookie.message': 'Ta strona używa plików cookie, aby poprawić Twoje wrażenia.',
      'cookie.accept': 'Akceptuj',
      'cookie.decline': 'Odrzuć',
      'story.section1': 'Cześć, jestem Léo. Jestem francusko-turecki i mieszkam w Normandii',
      'story.section2': 'Oto mój Tata i Ursule',
      'story.section3': 'Dwie rzeczy, które lubię robić: bawić się kolorami i nic nie robić',
      'story.section4': 'Ale cóż... trzeba też chodzić do szkoły każdego ranka',
      'story.section5': 'i w szkole miałem pewne trudności ze zrozumieniem rzeczy, które były łatwe do zrozumienia (według nauczycielki)',
      'story.section6': 'Ale na szczęście mój tata jest zbyt dobry w wymyślaniu rzeczy... więc próbowaliśmy znaleźć rozwiązania',
      'story.section7': 'I wtedy zorientowaliśmy się, że jestem synestetykiem (nawet nauczycielka nie znała tego słowa)',
      'story.section8': 'Razem zakodowaliśmy system do kojarzenia liter i kolorów',
      'story.section9': 'I wszystko stało się łatwiejsze',
      'story.section10': 'teraz jestem trochę starszy',
      'story.section11': 'W jednym z moich projektów studenckich zdecydowałem się otworzyć całemu światu to, co mój ojciec stworzył, aby mi pomóc',
      'story.section12': 'I to dało synesthesia.world',
      'story.section13': 'Ponieważ jesteśmy synestetykami.',
      'story.section14': 'Jesteśmy osobliwością',
      'story.morphing': 'Zabierz mnie',
      'login.storyLink': 'jak to wszystko się zaczęło',
      'blog.subtitle': 'Dzieła naszych synestetyków',
      'thecircle.title': 'Twój koło kolorów',
      'thecircle.loading': 'Ładowanie...',
      'thecircle.noMatrix': 'Najpierw musisz utworzyć macierz',
      'thecircle.createMatrix': 'Utwórz macierz',
      'thecircle.selectMatrix': 'Wybierz macierz:',
      'thecircle.share': 'Udostępnij',
      'thecircle.exportError': 'Błąd podczas eksportu:',
      'dashboard.sectionMatrices': 'Macierze',
      'dashboard.sectionDocuments': 'Dokumenty',
      'dashboard.matriceSubtitle': 'Utwórz i edytuj swoją macierz alfabet-kolory',
      'dashboard.historySubtitle': 'Przejrzyj historię swoich macierzy',
      'dashboard.circleTitle': 'Twój koło kolorów',
      'dashboard.circleSubtitle': 'Eksportuj swoje synestetyczne koło',
      'dashboard.documentSubtitle': 'Utwórz dokument z ostatnią macierzą',
      'dashboard.documentHistorySubtitle': 'Przejrzyj historię swoich dokumentów',
      'dashboard.animatedDocumentTitle': 'Animowany alfabet',
      'dashboard.animatedDocumentSubtitle': 'Utwórz dokument z animowanym alfabetem',
      'animatedEditor.title': 'Edytor animowanego tekstu',
      'animatedEditor.alphabet': 'Alfabet',
      'animatedEditor.letters': 'litery',
      'animatedEditor.selectAlphabet': 'Wybierz alfabet, aby rozpocząć',
      'animatedEditor.typeText': 'Wpisz tekst, aby zobaczyć animacje',
      'animatedEditor.loading': 'Ładowanie alfabetów...',
      'animatedEditor.placeholder': 'Wpisz swój tekst tutaj...',
      'animatedEditor.play': 'Odtwórz',
    },
  },
  ru: {
    translation: {
      'app.title': 'Synestesia',
      'auth.login': 'Войти',
      'auth.signup': 'Регистрация',
      'auth.email': 'Email',
      'auth.password': 'Пароль',
      'auth.confirmPassword': 'Подтвердите пароль',
      'auth.firstName': 'Имя',
      'auth.lastName': 'Фамилия',
      'auth.language': 'Язык',
      'auth.country': 'Страна',
      'auth.age': 'Возраст',
      'auth.submit': 'Отправить',
      'auth.logout': 'Выйти',
      'verifyEmail.title': 'Проверьте вашу почту',
      'verifyEmail.sentTo': 'Мы отправили ссылку для подтверждения на адрес:',
      'verifyEmail.steps': 'Следующие шаги:',
      'verifyEmail.step1': 'Откройте свою почту',
      'verifyEmail.step2': 'Нажмите на ссылку подтверждения в письме',
      'verifyEmail.step3': 'Ваш аккаунт будет активирован и вы сможете войти',
      'verifyEmail.resend': 'Отправить письмо повторно',
      'verifyEmail.sending': 'Отправка...',
      'verifyEmail.afterVerify': 'После подтверждения почты вы сможете войти.',
      'verifyEmail.goToLogin': 'Перейти на страницу входа →',
      'verifyEmail.emailNotAvailable': 'Адрес почты недоступен',
      'verifyEmail.resendSuccess': 'Письмо успешно отправлено',
      'verifyEmail.resendError': 'Ошибка при отправке письма',
      'emailVerification.loading': 'Проверка...',
      'emailVerification.pleaseWait': 'Пожалуйста, подождите',
      'emailVerification.success': 'Почта подтверждена!',
      'emailVerification.successMessage': 'Ваш адрес электронной почты был успешно подтверждён.',
      'emailVerification.error': 'Ошибка проверки',
      'emailVerification.errorMessage': 'Ссылка для подтверждения недействительна или истекла.',
      'emailVerification.loginNow': 'Войти сейчас',
      'emailVerification.goToLogin': 'Перейти к входу',
      'emailVerification.createAccount': 'Создать аккаунт',
      'emailVerification.missingParams': 'Отсутствуют параметры проверки.',
      'matrice.title': 'Создать матрицу',
      'matrice.letters': 'Буквы',
      'matrice.specialCharacters': 'Специальные символы',
      'matrice.numbers': 'Цифры',
      'matrice.days': 'Дни недели',
      'matrice.months': 'Месяцы года',
      'matrice.save': 'Сохранить',
      'matrice.loadLast': 'Загрузить последнюю матрицу',
      'dashboard.title': 'Панель управления',
      'document.title': 'Редактор документов',
      'document.new': 'Новый документ',
      'document.save': 'Сохранить',
      'document.exportPDF': 'Экспорт в PDF',
      'document.background': 'Фон',
      'document.previewWithColors': 'Предпросмотр с цветами',
      'document.keyboard': 'Клавиатура',
      'document.wordCount': 'слов',
      'document.wordCountOne': 'слово',
      'document.wordLimitExceeded': 'Превышен лимит в 3000 слов.',
      'document.loadError': 'Ошибка при загрузке документа',
      'document.saveError': 'Ошибка при сохранении документа',
      'documentHistory.title': 'История документов',
      'documentHistory.matrice': 'Матрица',
      'documentHistory.edit': 'Редактировать',
      'documentHistory.delete': 'Удалить',
      'documentHistory.deleting': 'Удаление...',
      'documentHistory.confirmDelete': 'Вы уверены, что хотите удалить этот документ?',
      'documentHistory.deleteError': 'Ошибка при удалении документа',
      'history.title': 'История матриц',
      'history.edit': 'Редактировать',
      'history.delete': 'Удалить',
      'history.confirmDelete': 'Вы уверены, что хотите удалить эту матрицу?',
      'history.deleteError': 'Ошибка при удалении',
      'matrice.basicGradient': 'Базовый градиент',
      'matrice.random': 'Случайно',
      'matrice.symbolSelect': 'Выбрать символ',
      'matrice.symbolFor': 'Символ для',
      'matrice.symbolMale': 'Мужской',
      'matrice.symbolFemale': 'Женский',
      'matrice.symbolIndeterminate': 'Неопределённый',
      'matrice.sensationDescribe': 'Опишите ощущение этой цифры',
      'matrice.sensationFor': 'Ощущение для',
      'matrice.sensationPlaceholder': 'Опишите ощущение этой цифры',
      'common.cancel': 'Отмена',
      'cookie.message': 'Этот сайт использует файлы cookie для улучшения вашего опыта.',
      'cookie.accept': 'Принять',
      'cookie.decline': 'Отклонить',
      'story.section1': 'Привет, я Лео. Я франко-турок и живу в Нормандии',
      'story.section2': 'Вот мой Папа и Урсула',
      'story.section3': 'Две вещи, которые я люблю делать: играть с цветами и ничего не делать',
      'story.section4': 'Но что ж... также нужно ходить в школу каждое утро',
      'story.section5': 'и в школе у меня были некоторые трудности с пониманием вещей, которые было легко понять (по словам учительницы)',
      'story.section6': 'Но к счастью, мой папа слишком хорош в изобретении вещей... поэтому мы попытались найти решения',
      'story.section7': 'И именно тогда мы поняли, что я синестетик (даже учительница не знала этого слова)',
      'story.section8': 'Мы вместе закодировали систему для ассоциации букв и цветов',
      'story.section9': 'И всё стало проще',
      'story.section10': 'теперь я немного старше',
      'story.section11': 'В одном из моих учебных проектов я решил открыть всему миру то, что мой отец создал, чтобы помочь мне',
      'story.section12': 'И это дало synesthesia.world',
      'story.section13': 'Потому что мы синестетики.',
      'story.section14': 'Мы сингулярность',
      'story.morphing': 'Возьми меня',
      'login.storyLink': 'как всё началось',
      'blog.subtitle': 'Произведения наших синестетиков',
      'thecircle.title': 'Ваш цветовой круг',
      'thecircle.loading': 'Загрузка...',
      'thecircle.noMatrix': 'Сначала необходимо создать матрицу',
      'thecircle.createMatrix': 'Создать матрицу',
      'thecircle.selectMatrix': 'Выберите матрицу:',
      'thecircle.share': 'Поделиться',
      'thecircle.exportError': 'Ошибка при экспорте:',
      'dashboard.sectionMatrices': 'Матрицы',
      'dashboard.sectionDocuments': 'Документы',
      'dashboard.matriceSubtitle': 'Создавайте и редактируйте свою матрицу алфавит-цвета',
      'dashboard.historySubtitle': 'Просмотрите историю ваших матриц',
      'dashboard.circleTitle': 'Ваш цветовой круг',
      'dashboard.circleSubtitle': 'Экспортируйте свой синестетический круг',
      'dashboard.documentSubtitle': 'Создайте документ с вашей последней матрицей',
      'dashboard.documentHistorySubtitle': 'Просмотрите историю ваших документов',
      'dashboard.animatedDocumentTitle': 'Анимированный алфавит',
      'dashboard.animatedDocumentSubtitle': 'Создайте документ с анимированным алфавитом',
      'animatedEditor.title': 'Редактор анимированного текста',
      'animatedEditor.alphabet': 'Алфавит',
      'animatedEditor.letters': 'букв',
      'animatedEditor.selectAlphabet': 'Выберите алфавит для начала',
      'animatedEditor.typeText': 'Введите текст, чтобы увидеть анимации',
      'animatedEditor.loading': 'Загрузка алфавитов...',
      'animatedEditor.placeholder': 'Введите ваш текст здесь...',
    },
  },
  uk: {
    translation: {
      'app.title': 'Synestesia',
      'auth.login': 'Увійти',
      'auth.signup': 'Реєстрація',
      'auth.email': 'Email',
      'auth.password': 'Пароль',
      'auth.confirmPassword': 'Підтвердіть пароль',
      'auth.firstName': 'Ім\'я',
      'auth.lastName': 'Прізвище',
      'auth.language': 'Мова',
      'auth.country': 'Країна',
      'auth.age': 'Вік',
      'auth.submit': 'Відправити',
      'auth.logout': 'Вийти',
      'verifyEmail.title': 'Перевірте вашу пошту',
      'verifyEmail.sentTo': 'Ми надіслали посилання для підтвердження на адресу:',
      'verifyEmail.steps': 'Наступні кроки:',
      'verifyEmail.step1': 'Відкрийте свою пошту',
      'verifyEmail.step2': 'Натисніть на посилання підтвердження в листі',
      'verifyEmail.step3': 'Ваш обліковий запис буде активовано і ви зможете увійти',
      'verifyEmail.resend': 'Надіслати лист повторно',
      'verifyEmail.sending': 'Надсилання...',
      'verifyEmail.afterVerify': 'Після підтвердження пошти ви зможете увійти.',
      'verifyEmail.goToLogin': 'Перейти на сторінку входу →',
      'verifyEmail.emailNotAvailable': 'Адреса пошти недоступна',
      'verifyEmail.resendSuccess': 'Лист успішно надіслано',
      'verifyEmail.resendError': 'Помилка при надсиланні листа',
      'emailVerification.loading': 'Перевірка...',
      'emailVerification.pleaseWait': 'Будь ласка, зачекайте',
      'emailVerification.success': 'Пошту підтверджено!',
      'emailVerification.successMessage': 'Вашу адресу електронної пошти було успішно підтверджено.',
      'emailVerification.error': 'Помилка перевірки',
      'emailVerification.errorMessage': 'Посилання для підтвердження недійсне або закінчилося.',
      'emailVerification.loginNow': 'Увійти зараз',
      'emailVerification.goToLogin': 'Перейти до входу',
      'emailVerification.createAccount': 'Створити обліковий запис',
      'emailVerification.missingParams': 'Відсутні параметри перевірки.',
      'matrice.title': 'Створити матрицю',
      'matrice.letters': 'Літери',
      'matrice.specialCharacters': 'Спеціальні символи',
      'matrice.numbers': 'Цифри',
      'matrice.days': 'Дні тижня',
      'matrice.months': 'Місяці року',
      'matrice.save': 'Зберегти',
      'matrice.loadLast': 'Завантажити останню матрицю',
      'dashboard.title': 'Панель керування',
      'document.title': 'Редактор документів',
      'document.new': 'Новий документ',
      'document.save': 'Зберегти',
      'document.exportPDF': 'Експорт в PDF',
      'document.background': 'Фон',
      'document.previewWithColors': 'Попередній перегляд з кольорами',
      'document.keyboard': 'Клавіатура',
      'document.wordCount': 'слів',
      'document.wordCountOne': 'слово',
      'document.wordLimitExceeded': 'Перевищено ліміт у 3000 слів.',
      'document.loadError': 'Помилка при завантаженні документа',
      'document.saveError': 'Помилка при збереженні документа',
      'documentHistory.title': 'Історія документів',
      'documentHistory.matrice': 'Матриця',
      'documentHistory.edit': 'Редагувати',
      'documentHistory.delete': 'Видалити',
      'documentHistory.deleting': 'Видалення...',
      'documentHistory.confirmDelete': 'Ви впевнені, що хочете видалити цей документ?',
      'documentHistory.deleteError': 'Помилка при видаленні документа',
      'history.title': 'Історія матриць',
      'history.edit': 'Редагувати',
      'history.delete': 'Видалити',
      'history.confirmDelete': 'Ви впевнені, що хочете видалити цю матрицю?',
      'history.deleteError': 'Помилка при видаленні',
      'matrice.basicGradient': 'Базовий градієнт',
      'matrice.random': 'Випадково',
      'matrice.symbolSelect': 'Вибрати символ',
      'matrice.symbolFor': 'Символ для',
      'matrice.symbolMale': 'Чоловічий',
      'matrice.symbolFemale': 'Жіночий',
      'matrice.symbolIndeterminate': 'Невизначений',
      'matrice.sensationDescribe': 'Опишіть відчуття цієї цифри',
      'matrice.sensationFor': 'Відчуття для',
      'matrice.sensationPlaceholder': 'Опишіть відчуття цієї цифри',
      'common.cancel': 'Скасувати',
      'cookie.message': 'Цей сайт використовує файли cookie для покращення вашого досвіду.',
      'cookie.accept': 'Прийняти',
      'cookie.decline': 'Відхилити',
      'story.section1': 'Привіт, я Лео. Я франко-турок і живу в Нормандії',
      'story.section2': 'Ось мій Тато і Урсула',
      'story.section3': 'Дві речі, які я люблю робити: грати з кольорами і нічого не робити',
      'story.section4': 'Але що ж... також потрібно ходити до школи кожного ранку',
      'story.section5': 'і в школі у мене були деякі труднощі з розумінням речей, які було легко зрозуміти (за словами вчительки)',
      'story.section6': 'Але на щастя, мій тато занадто хороший у винаходженні речей... тому ми спробували знайти рішення',
      'story.section7': 'І саме тоді ми зрозуміли, що я синестетик (навіть вчителька не знала цього слова)',
      'story.section8': 'Ми разом закодували систему для асоціації букв і кольорів',
      'story.section9': 'І все стало простіше',
      'story.section10': 'тепер я трохи старший',
      'story.section11': 'В одному з моїх навчальних проектів я вирішив відкрити всьому світу те, що мій батько створив, щоб допомогти мені',
      'story.section12': 'І це дало synesthesia.world',
      'story.section13': 'Тому що ми синестетики.',
      'story.section14': 'Ми сингулярність',
      'story.morphing': 'Візьми мене',
      'login.storyLink': 'як все почалося',
      'blog.subtitle': 'Твори наших синестетиків',
      'dashboard.sectionMatrices': 'Матриці',
      'dashboard.sectionDocuments': 'Документи',
      'dashboard.matriceSubtitle': 'Створюйте та редагуйте свою матрицю алфавіт-кольори',
      'dashboard.historySubtitle': 'Перегляньте історію своїх матриць',
      'dashboard.circleTitle': 'Ваше коло кольорів',
      'dashboard.circleSubtitle': 'Експортуйте своє синестетичне коло',
      'dashboard.documentSubtitle': 'Створіть документ зі своєю останньою матрицею',
      'dashboard.documentHistorySubtitle': 'Перегляньте історію своїх документів',
      'dashboard.animatedDocumentTitle': 'Анімований алфавіт',
      'dashboard.animatedDocumentSubtitle': 'Створіть документ з анімованим алфавітом',
      'animatedEditor.title': 'Редактор анімованого тексту',
      'animatedEditor.alphabet': 'Алфавіт',
      'animatedEditor.letters': 'літер',
      'animatedEditor.selectAlphabet': 'Виберіть алфавіт, щоб почати',
      'animatedEditor.typeText': 'Введіть текст, щоб побачити анімації',
      'animatedEditor.loading': 'Завантаження алфавітів...',
      'animatedEditor.placeholder': 'Введіть ваш текст тут...',
      'animatedEditor.play': 'Відтворити',
    },
  },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: localStorage.getItem('language') || 'fr',
    fallbackLng: 'fr',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;

